/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_UsInputs */

const en_follow_us = /** @type {(inputs: Follow_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow us`)
};

const th_follow_us = /** @type {(inputs: Follow_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดตามเรา`)
};

const ja_follow_us = /** @type {(inputs: Follow_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォローする`)
};

const fr_follow_us = /** @type {(inputs: Follow_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivez-nous`)
};

const es_follow_us = /** @type {(inputs: Follow_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Síguenos`)
};

const ru_follow_us = /** @type {(inputs: Follow_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы в соцсетях`)
};

const zh_follow_us = /** @type {(inputs: Follow_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关注我们`)
};

const vi_follow_us = /** @type {(inputs: Follow_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo dõi chúng tôi`)
};

/**
* | output |
* | --- |
* | "Follow us" |
*
* @param {Follow_UsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const follow_us = /** @type {((inputs?: Follow_UsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_UsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_follow_us(inputs)
	if (locale === "ja") return ja_follow_us(inputs)
	if (locale === "fr") return fr_follow_us(inputs)
	if (locale === "es") return es_follow_us(inputs)
	if (locale === "ru") return ru_follow_us(inputs)
	if (locale === "zh") return zh_follow_us(inputs)
	if (locale === "vi") return vi_follow_us(inputs)
	return en_follow_us(inputs)
});